import { Node, mergeAttributes } from '@tiptap/core';
import { VueNodeViewRenderer } from '@tiptap/vue-3';
import TocNodeView from './TocNodeView.vue';

declare module '@tiptap/core' {
    interface Commands<ReturnType> {
        toc: {
            /** Insert a Table of Contents block at the current position. */
            insertToc: () => ReturnType;
        };
    }
}

/**
 * Block atom that renders a live Table of Contents.
 * It is a singleton — insertToc is a no-op if one already exists.
 * The actual heading list is computed in TocNodeView from the live editor state.
 */
export const TocExtension = Node.create({
    name: 'toc',

    group: 'block',

    atom: true,

    draggable: true,

    addAttributes() {
        return {
            title: {
                default: 'Table des matières',
                parseHTML: (el) =>
                    el.getAttribute('data-toc-title') ?? 'Table des matières',
                renderHTML: (attrs) => ({ 'data-toc-title': attrs.title }),
            },
        };
    },

    parseHTML() {
        return [{ tag: 'div[data-toc]' }];
    },

    renderHTML({ HTMLAttributes }) {
        return ['div', mergeAttributes(HTMLAttributes, { 'data-toc': '' }), 0];
    },

    addNodeView() {
        return VueNodeViewRenderer(TocNodeView);
    },

    addCommands() {
        return {
            insertToc:
                () =>
                ({ state, commands }) => {
                    // Prevent duplicate TOCs
                    let exists = false;
                    state.doc.descendants((node) => {
                        if (node.type.name === 'toc') {
                            exists = true;

                            return false;
                        }

                        return true;
                    });

                    if (exists) {
                        return true;
                    }

                    return commands.insertContent({ type: 'toc' });
                },
        };
    },
});
